export default "__VITE_ASSET__DElCAzf0__"